var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!!_vm.icon)?_c('v-icon',{class:_vm.className,attrs:{"left":""},domProps:{"textContent":_vm._s(_vm.icon)}}):_vm._e(),_c('span',{staticClass:"text-body-2",class:[
      _vm.className,
      {
        'font-weight-bold': _vm.bold,
      } ]},[_vm._t("default")],2),_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"rules":[function (v) { return !_vm.fixRequired; }]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }